import type { ReactNode } from 'react';

export interface IFaqItem {
  value: string;
  question: string;
  answer: ReactNode;
}

export const WORKER_TYPE_FAQ: IFaqItem[] = [
  {
    value: 'faq-choose-now',
    question: 'Do I have to choose my worker type right now?',
    answer:
      "No! If you aren't ready to select a worker type during sign up, you can bypass the selection by choosing \"I'm not sure, I'll decide later\". However, please note that you won't be able to post shifts until the Type of Worker is selected. You can submit your selection at a later time by navigating to Account > Worker Type.",
  },
  {
    value: 'faq-change-later',
    question: 'Can I change my worker type after I set it?',
    answer:
      'At this time, it is not possible to change your worker type once it is set. However, we are working to make this possible in the future.',
  },
  {
    value: 'faq-pricing',
    question: 'Is there a pricing difference between the two worker types?',
    answer:
      'Yes. Due to the different structures comprising classification, there are pricing differences.\n\n• Contractor Option: Only pay the GoTu Service Fee\n• Employee Option: Pay the GoTu Service Fee + Employee Fee (20% of professional pay)',
  },
  {
    value: 'faq-experience',
    question: 'Will my experience on GoTu differ depending upon my worker type selection?',
    answer:
      "We're working to ensure that the product experience will be very similar, if not the exact same. This applies to the in-platform user experience, support, and account resources.",
  },
  {
    value: 'faq-cancellation',
    question: 'What happens to the Employee Fee if I cancel a confirmed shift?',
    answer:
      "We've kept the same timeframes for cancellation fees under both classifications. Therefore, any cancellation fees for the Employee Fee will depend upon the time of cancellation relative to the shift start time. If a confirmed shift is cancelled by an office less than 4 days before the shift, the office will be responsible for 100% of the Employee Fee.",
  },
  {
    value: 'faq-multi-office',
    question:
      'What if my office is under the legal entity of a larger business group? (Ex: Multi-Office private practice)',
    answer:
      'If your practice operates under the same legal entity as other practices within a given state, you must all set the same worker type. Please consult with your business group to decide which worker option applies to your office.',
  },
];

export const PSA_DESCRIPTION =
  "We will be providing professionals that are employed through Paychex, GoTu's Professional Employment Organization (PEO). Please read through and accept the Personnel Service Agreement to begin looking for coverage!";

export const EDUCATIONAL_PARAGRAPHS = [
  'Worker Type refers to the type of worker, specifically, whether individual professionals will be engaged as independent contractors that have chosen to offer professional services through the GoTu platform (“Contractor Option”) or as employees of our PEO (GoTu’s Professional Employer Organization) that are sent to your office to provide services (“Employee Option”).',
  'To be able to post shifts on GoTu, your office must select a worker classification. It is important to remember that groups of offices that share the same Tax Identification Number (TIN), must select the same worker type, if available.',
];

export const DISCLAIMER =
  'Disclaimer: GoTu is not providing legal or tax advice. It is up to the office’s discretion to determine which worker type best suits their needs.';

export const BANNER_COPY =
  "Selecting your office's worker type is required to finalize your sign up. Please select one of the options at the bottom, then continue.";
